"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classCombine = exports.snakeify = exports.parseSSNString = exports.isValidPhoneNumber = exports.parsePhoneString = exports.flattenObjectAndParse = exports.parseStringUnderScores = void 0;
const parseStringUnderScores = (s) => {
    if (!s)
        return "";
    let words = s.split("_");
    words[0] === "" ? words.shift() : null;
    let parsedString = words[0][0].toUpperCase() + words[0].slice(1);
    for (let i = 1; i < words.length; i++) {
        if (words[i] === "id") {
            words[i] = "ID";
        }
        if (words[i] === "pm") {
            words[i] = "PM";
        }
        parsedString = parsedString + " " + words[i][0].toUpperCase() + words[i].slice(1);
    }
    return parsedString;
};
exports.parseStringUnderScores = parseStringUnderScores;
/**
 * Flattens Object to 1 depth.
 * Parses keys and formats them ("ex_key" => "Ex Key").
 * @param o
 * @param template
 * @returns Object
 */
const flattenObjectAndParse = (o, template) => {
    const newObject = {};
    for (const key in (template ?? o)) {
        if (typeof o[key] === 'object') {
            for (const key2 in o[key]) {
                newObject[(0, exports.parseStringUnderScores)(key2)] = o[key][key2];
            }
        }
        else {
            newObject[(0, exports.parseStringUnderScores)(key)] = o[key];
        }
    }
    return newObject;
};
exports.flattenObjectAndParse = flattenObjectAndParse;
/**
 * Parses phone string from input and transforms it into (XXX) XXX-XXXX format.
 * @param s
 * @returns string
 */
const parsePhoneString = (s) => {
    let phoneString = s.replace(/[^0-9]/g, "");
    const numDigits = phoneString.replace(/[^0-9]/g, "");
    if (numDigits.length > 2 && phoneString.charAt(0) !== "(") {
        phoneString = "(" + numDigits.slice(0, 3);
    }
    if (numDigits.length > 3 && phoneString.indexOf(")") < 0) {
        phoneString = "(" + numDigits.slice(0, 3) + ") " + numDigits.slice(3);
    }
    if (numDigits.length > 6 && phoneString.indexOf("-") < 0) {
        phoneString = "(" + numDigits.slice(0, 3) + ") " + numDigits.slice(3, 6) + "-" + numDigits.slice(6);
    }
    if (numDigits.length > 10)
        phoneString = phoneString.slice(0, 14);
    return phoneString;
};
exports.parsePhoneString = parsePhoneString;
/**
 * Parses phone string (in any format), and returns a boolean value if it is a valid phone number or not.
 * @param s
 * @returns boolean
 */
const isValidPhoneNumber = (s) => {
    if (!s)
        return false;
    return s.replace(/[^0-9]/g, "").length === 10;
};
exports.isValidPhoneNumber = isValidPhoneNumber;
/**
 * Parses SSN string from input and transform it into XXX-XX-XXXX format.
 * @param ssn
 * @returns string
 */
const parseSSNString = (ssn) => {
    let newString = ssn.replace(/[^0-9]/g, "");
    const numDigits = ssn.replace(/[^0-9]/g, "");
    if (numDigits.length > 3 && newString.charAt(3) !== "-") {
        newString = numDigits.slice(0, 3) + "-" + numDigits.slice(3);
    }
    if (numDigits.length > 5 && newString.charAt(6) !== "-") {
        newString = numDigits.slice(0, 3) + "-" + numDigits.slice(3, 5) + "-" + numDigits.slice(5);
    }
    if (numDigits.length > 9)
        return newString.slice(0, 11);
    return newString;
};
exports.parseSSNString = parseSSNString;
/**
 * Parses a string and returns in snake case.
 * EX: Test String -> test_string
 * @param key
 * @returns string | undefined
 */
const snakeify = (key) => {
    if (!key)
        return undefined;
    return key.toLowerCase().trim().replaceAll(" ", "_");
};
exports.snakeify = snakeify;
/**
 * Parses an array of string and combines them into a className string.
 * EX: ["hello", "world", undefined, "parent"] -> "hello world parent"
 * @param args
 * @returns string
 */
function classCombine(...args) {
    return args.reduce((acc, $className) => {
        const className = typeof $className === "boolean" ? "" : $className;
        if (!className)
            return acc;
        return acc + className + " ";
    }, "").trim();
}
exports.classCombine = classCombine;
